import { Controller } from 'stimulus'

export default class extends Controller {

  initialize() {
    grecaptcha.render("recaptchaV2", { sitekey: this.element.dataset.siteKey })
  }
}
